import { useTheme } from "@mui/material/styles";
const useTheme_useTheme = ()=>{
    const theme = useTheme();
    return theme.tokens.name;
};
export { useTheme_useTheme as useTheme };
